import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { EmptyStateProps } from 'modules/finance/components/FinancialWorkspace/components/Table/types'

interface Props {
  filtersApplied: boolean
  emptyStateProps: EmptyStateProps
}

export const EmptyStateTable = ({ filtersApplied, emptyStateProps }: Props) => {
  if (filtersApplied) {
    return (
      <OneEmptyState
        emoji={emptyStateProps.filtersEmoji}
        title={i18n.t('finance.financial_workspace.breakdown_table.search.no_results.title')}
        description={i18n.t(
          'finance.financial_workspace.breakdown_table.search.no_results.description'
        )}
      />
    )
  }

  return (
    <OneEmptyState
      emoji={emptyStateProps.emoji}
      title={emptyStateProps.title}
      actions={emptyStateProps.actions?.()}
      description={emptyStateProps.description}
    />
  )
}
